/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SafeLocation } from './SafeLocation';
import {
    SafeLocationFromJSON,
    SafeLocationFromJSONTyped,
    SafeLocationToJSON,
    SafeLocationToJSONTyped,
} from './SafeLocation';

/**
 * 
 * @export
 * @interface SafeDepositBoxSafeLocationOption
 */
export interface SafeDepositBoxSafeLocationOption {
    /**
     * 
     * @type {SafeLocation}
     * @memberof SafeDepositBoxSafeLocationOption
     */
    value: SafeLocation;
    /**
     * 
     * @type {string}
     * @memberof SafeDepositBoxSafeLocationOption
     */
    label: string;
}



/**
 * Check if a given object implements the SafeDepositBoxSafeLocationOption interface.
 */
export function instanceOfSafeDepositBoxSafeLocationOption(value: object): value is SafeDepositBoxSafeLocationOption {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function SafeDepositBoxSafeLocationOptionFromJSON(json: any): SafeDepositBoxSafeLocationOption {
    return SafeDepositBoxSafeLocationOptionFromJSONTyped(json, false);
}

export function SafeDepositBoxSafeLocationOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDepositBoxSafeLocationOption {
    if (json == null) {
        return json;
    }
    return {
        
        'value': SafeLocationFromJSON(json['value']),
        'label': json['label'],
    };
}

export function SafeDepositBoxSafeLocationOptionToJSON(json: any): SafeDepositBoxSafeLocationOption {
    return SafeDepositBoxSafeLocationOptionToJSONTyped(json, false);
}

export function SafeDepositBoxSafeLocationOptionToJSONTyped(value?: SafeDepositBoxSafeLocationOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': SafeLocationToJSON(value['value']),
        'label': value['label'],
    };
}

